import { type ReactNode, useContext } from 'react'

import { CartContext } from '@lib/cart/context'
import { StringsContext } from '@lib/strings-context'

import Button, {
  type ButtonProps,
  ButtonSize,
} from '@components/buttons/button'

type ProductAddToCartProps = ButtonProps & {
  onClick: () => void
  disabled?: boolean
  className?: string
  children: ReactNode
}

const ProductAddToCart = ({
  onClick,
  variant,
  color,
  size = ButtonSize.NORMAL,
  icon,
  disabled,
  className,
  children,
}: ProductAddToCartProps) => {
  const strings = useContext(StringsContext)
  const { cart, cartAddingProductIds } = useContext(CartContext)

  return (
    <Button
      id="product-add-to-cart-button"
      className={className}
      variant={variant}
      color={color}
      size={size}
      icon={icon}
      disabled={!!disabled || !cart || cartAddingProductIds.length > 0}
      onClick={onClick}
    >
      {!cart && <>{strings.buttonUnavailable}</>}
      {!!cart && cartAddingProductIds.length > 0 && <>{strings.buttonAdding}</>}
      {!!cart && cartAddingProductIds.length === 0 && <>{children}</>}
    </Button>
  )
}

export default ProductAddToCart
